import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LocalizePipe } from '@capital-access/common/localization';
import { CommonLocalizationModule } from '@capital-access/common/localization';
import { COMMON_COMPONENTS_LOCALIZATION_SCOPE } from '../common-components.const';

@Component({
  selector: 'ca-cookie-settings-button',
  imports: [LocalizePipe, CommonLocalizationModule],
  template: `
    <button
      id="ot-sdk-btn"
      class="ot-sdk-show-settings btn btn-link text-decoration-none text-default p-0"
      aria-label="Cookie Settings"
      type="button"
      [caLocalizationScope]="localizationScope"
    >
      {{ 'cookieSettings' | caLocalize }}
    </button>
  `,
  styles: [
    `
      :host {
        display: inline-block;
      }
      .btn-link {
        font-size: 0.85rem;
        color: inherit;
        baground: transparent;
      }
      .ot-sdk-show-settings {
        background-color: none !important;
      }
      .btn.btn-link:focus-visible {
        box-shadow: none !important;
      }
      .ot-sdk-show-settings:active {
        border: none !important;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CookieSettingsButtonComponent {
  localizationScope = COMMON_COMPONENTS_LOCALIZATION_SCOPE;
}
